import { useEffect, useState } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { LoaderCircle } from "lucide-react"
import { Button } from "@/components/ui/button"
import { ApiError, api } from "@/lib/api"

type AuthState = "loading" | "authenticated" | "unauthenticated" | "error"

export function AuthGuard() {
  const location = useLocation()
  const [state, setState] = useState<AuthState>("loading")

  useEffect(() => {
    let cancelled = false
    void api.me()
      .then(() => { if (!cancelled) setState("authenticated") })
      .catch((error: unknown) => {
        if (cancelled) return
        setState(error instanceof ApiError && error.status !== 401 ? "error" : "unauthenticated")
      })
    return () => { cancelled = true }
  }, [])

  if (state === "loading") {
    return (
      <main className="app-grid flex min-h-screen items-center justify-center" aria-busy="true">
        <LoaderCircle className="size-5 animate-spin text-primary" aria-label="Carregando" />
      </main>
    )
  }

  if (state === "error") {
    return (
      <main className="app-grid flex min-h-screen items-center justify-center p-6 text-center">
        <div>
          <p className="font-display text-lg font-bold">Não foi possível verificar sua sessão</p>
          <p className="mt-2 text-sm text-muted-foreground">A API pode ainda estar iniciando.</p>
          <Button className="mt-5" onClick={() => window.location.reload()}>Tentar novamente</Button>
        </div>
      </main>
    )
  }

  if (state === "unauthenticated") {
    const destination = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/login" replace state={{ from: destination }} />
  }

  return <Outlet />
}
